module.exports = __webpack_public_path__ + "static/media/semoule.f8dfc62d.svg";